let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
    let templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/event.js?v=129793407935769848231760095898");
  loadScript("https://bridge.shopflo.com/js/shopflo.bundle.js");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/devx-script.js?v=51549546263141444671760095895");  
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/all.min.js?v=155899187558914370431760095895");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/product-form.js?v=57800217465557518881760095897");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/cart-notification.js?v=133508293167896966491760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/search-form.js?v=133129549252120666541760095899");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/quantity-popover.js?v=987015268078116491760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/shop-all.js?v=143197897513113412691760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/quick-add.js?v=73073840428863680991760095896");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/facets.js?v=46295235780883033701760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/show-more.js?v=135784227224860024771760095895");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/st_offers.js?v=76932910831040468011760095897");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/predictive-search.js?v=162273246065392412141760095895");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/dk-internal.js?v=155117357220689533331761941984");

 
  

  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/quantity-popover.css?v=76231206801088522361760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-color-swatch.css?v=146727391458662814791760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/all.min.css?v=36347114306294163891760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-price.css?v=70172745017360139101760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-card.css?v=158102377163184793191761126905");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart.css?v=49529066954642232561760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-mega-menu.css?v=122458266873942644791760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-totals.css?v=45024014013762792871760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart-drawer.css?v=162987023708451632291760095897");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-discounts.css?v=152760482443307489271760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/searchtap.css?v=111603181540343972631760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-list-menu.css?v=151968516119678728991760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-search.css?v=165164710990765432851760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-menu-drawer.css?v=20646116693146970981760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart-notification.css?v=54116361853792938221760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart-items.css?v=47901327362710772261760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-collection-hero.css?v=150137544140055157131760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/quick-add.css?v=66647833350618835731760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-show-more.css?v=139536189637226996221760095897");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-swatch-input.css?v=61683592951238328641760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-swatch.css?v=68619770617697936771760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/cart-drawer-new-ui-extra-css.css?v=68135823986598657811761940935");
   
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/details-modal.js?v=119528565511025453401760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/details-disclosure.js?v=13653116266235556501760095898");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);   
  }, 10);

}
// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
